import QueryFilters from "Components/QueryInterface";

export const QueryInterface = () => {
    return (
        <div className="flex w-full p-6">
           <QueryFilters />
        </div>
    );
}